/**
 * What to tell the client when an onboarding request is refused.
 *
 * The server answers a refusal the client can act on with a code in `error`
 * (`PublicError`, backend `platform/public-error.ts`), which `fetchServer`
 * turns into the thrown message. A known code gets its sentence; anything else
 * — a crash, a network error, a code this build does not know — gets
 * `fallbackKey`, never the raw text: that was an English sentence or "Internal
 * server error" shown as is to a French client.
 */

const CODES = [
  "already_completed",
  "website_or_description_required",
  "mobile_required",
  "mobile_not_verified",
  "not_completed",
  "no_demo_line",
  "callback_limit",
] as const;

export const onboardingErrorMessage = (
  error: unknown,
  t: (key: string) => string,
  fallbackKey = "errors.generic",
): string => {
  const code = error instanceof Error ? error.message : "";
  return (CODES as readonly string[]).includes(code)
    ? t(`errors.codes.${code}`)
    : t(fallbackKey);
};
